import styled from "styled-components"
import {
  HeaderSection,
  HeadingContainer,
  HeadingDescription,
  HeadingTitle,
} from "../Preview/styled"
import ImageScanningAnimation from "./ScanningAnimation"
import ScanningLoading from "./ScanningLoading"

const Wrapper = styled.div`
  background: #fff;
  height: calc(100% - var(--header-height));
`

const Scanning = ({ imageUrl }: { imageUrl: string }) => {
  return (
    <Wrapper>
      <HeaderSection>
        <HeadingContainer>
          <HeadingTitle>Photo Uploaded</HeadingTitle>
          <HeadingDescription>
            Analyzing your image… this may take a few moments.
          </HeadingDescription>
        </HeadingContainer>
      </HeaderSection>
      <ImageScanningAnimation imageUrl={imageUrl} />
      <ScanningLoading />
    </Wrapper>
  )
}

export default Scanning
